import { c as _c } from "react/compiler-runtime";
import { SkillBadge } from '@/app/(marketing-site)/(portfolio)/_components/SkillBadge';
import type { TagGeneralSkillLevel } from '@/common/enums';
import { P2 } from '@/frontend/design-system/typography/Paragraph';
type WorkExperience = {
  company: string;
  role: string;
  description: string;
  from: string;
  to?: string | null;
  skills: {
    name: string;
    level: TagGeneralSkillLevel;
  }[];
};
type ExperienceItemProps = {
  experience: WorkExperience;
};
export function ExperienceItem(t0) {
  const $ = _c(20);
  const {
    experience
  } = t0;
  const t1 = experience.to ? `${experience.from} - ${experience.to}` : experience.from;
  let t2;
  if ($[0] !== t1) {
    t2 = <P2 className="text-nowrap text-contentTertiary lg:w-28 lg:shrink-0">{t1}</P2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== experience.role) {
    t3 = <P2 className="font-bold text-contentPrimary">{experience.role}</P2>;
    $[2] = experience.role;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== experience.company) {
    t4 = <P2 className="font-medium text-contentSecondary">{experience.company}</P2>;
    $[4] = experience.company;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="flex flex-row flex-wrap gap-2 align-start">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== experience.description) {
    t6 = <P2 className="text-contentSecondary">{experience.description}</P2>;
    $[9] = experience.description;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== experience.skills) {
    t7 = experience.skills && experience.skills.length > 0 && <div className="flex flex-row flex-wrap gap-3">{experience.skills.map(_temp)}</div>;
    $[11] = experience.skills;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className="min-w-0 space-y-3">{t5}{t6}{t7}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t2 || $[18] !== t8) {
    t9 = <div className="flex flex-col items-start gap-4 lg:flex-row lg:gap-5">{t2}{t8}</div>;
    $[17] = t2;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function _temp(skill) {
  return <SkillBadge key={skill.name} skill={skill.name} />;
}